import Vue from 'vue';
import Router from 'vue-router';
import ProductModule from "@/enums/productModule";
import FeatureId from '@/enums/featureId';
import PermissionAction from '@/enums/permissionAction';
import store from '@/store';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => import('@/pages/PageHome' /* webpackChunkName: "home" */)
		},
		{
			path: '/assets/',
			name: 'assets',
			component: () => import('@/pages/assets/PageAssets' /* webpackChunkName: "assets" */),
			meta: { featureId: FeatureId.ASSET_MANAGER_MANAGE, action: PermissionAction.USE }
		},
		{
			path: '/assets/:id',
			name: 'asset',
			component: () => import('@/pages/assets/PageAsset' /* webpackChunkName: "assets" */),
			props: true,
			meta: { featureId: FeatureId.ASSET_MANAGER_MANAGE, action: PermissionAction.USE }
		},
		{
			path: '/assets/create',
			name: 'assetCreate',
			component: () => import('@/pages/assets/PageAssetCreate' /* webpackChunkName: "assets" */),
			meta: { featureId: FeatureId.ASSET_MANAGER_MANAGE, action: PermissionAction.USE }
		},
		{
			path: '/employees/',
			name: 'employees',
			component: () => import('@/pages/employee/PageEmployees' /* webpackChunkName: "employees" */)
		},
		{
			path: '/employee/create/',
			name: 'employeeCreate',
			component: () => import('@/pages/employee/PageEmployeeCreate' /* webpackChunkName: "employees" */)
		},
		{
			path: '/employee/:id',
			name: 'employee',
			component: () => import('@/pages/employee/PageEmployee' /* webpackChunkName: "employees" */),
			props: true
		},
		{
			path: '/employee/:id/certifications',
			name: 'employeeCertifications',
			component: () => import('@/pages/employee/PageEmployee' /* webpackChunkName: "employees" */),
			props: true
		},
		{
			path: '/employee/:id/certifications/:certificationId',
			name: 'employeeCertificationsWithId',
			component: () => import('@/pages/employee/PageEmployee' /* webpackChunkName: "employees" */),
			props: true
		},
		{
			path: '/employee/:employeeId/compliance',
			name: 'employeeCompliance',
			component: () => import('@/pages/compliance/PageEmployeeCompliance' /* webpackChunkName: "compliance" */),
			props: true
		},
		{
			path: '/employee/:employeeId/goals/:id',
			name: 'employeeGoal',
			component: () => import('@/pages/goals/PageGoal' /* webpackChunkName: "goals" */),
			props: true
		},
		{
			path: '/employee/:employeeId/position/:id',
			name: 'employeePosition',
			component: () => import('@/pages/employee/PageEmployeePosition' /* webpackChunkName: "employees" */),
			props: true
		},
		{
			meta: {
                requiredModule: ProductModule.PerformanceReviews
			},
			path: '/prs',
			name: 'prs',
			component: () => import('@/pages/performanceReviews/PagePerformanceReviews' /* webpackChunkName: "prs" */)
		},
		{
			path: '/pr/create/',
			name: 'prCreate',
			component: () => import('@/pages/performanceReviews/PagePerformanceReviewCreate' /* webpackChunkName: "prs" */),
			props: true
		},
		{
			path: '/pr/:id',
			name: 'pr',
			component: () => import('@/pages/performanceReviews/PagePerformanceReview' /* webpackChunkName: "prs" */),
			props: true
		},
		{
			path: '/pr/:id/report',
			name: 'prReport',
			component: () => import('@/pages/performanceReviews/PagePerformanceReviewReport' /* webpackChunkName: "prs" */),
			props: true
		},
		{
			path: '/pr/:id/discussion',
			name: 'prDiscussion',
			component: () => import('@/pages/performanceReviews/PagePerformanceReviewDiscussion' /* webpackChunkName: "prs" */),
			props: true
		},
		{
			path: '/pr/:id/edit',
			name: 'prEdit',
			component: () => import('@/pages/performanceReviews/PagePerformanceReviewEdit' /* webpackChunkName: "prs" */),
			props: true
		},
		{
			path: '/pr/:id/submit/:submitId',
			name: 'prSubmit',
			component: () => import('@/pages/performanceReviews/PagePerformanceReviewSubmitEdit' /* webpackChunkName: "prs" */),
			props: true
		},
		{
			path: '/pr/:id/submit/:submitId/edit',
			name: 'prSubmitEdit',
			component: () => import('@/pages/performanceReviews/PagePerformanceReviewSubmitEdit' /* webpackChunkName: "prs" */),
			props: true
		},
		{
			path: "/prs/settings",
			name: "prSettings",
			component: () => import("@/pages/performanceReviews/PagePerformanceReviewSettings" /* webpackChunkName: "prs" */)
		},
		{
			path: '/checkIns',
			name: 'checkIns',
			component: () => import('@/pages/checkins/PageCheckIns' /* webpackChunkName: "checkIns" */)
		},
		{
			path: '/checkIn/create/',
			name: 'checkInCreate',
			component: () => import('@/pages/checkins/PageCheckInCreate' /* webpackChunkName: "checkIns" */)
		},
		{
			path: '/checkIn/:id',
			name: 'checkIn',
			component: () => import('@/pages/checkins/PageCheckIn' /* webpackChunkName: "checkIns" */),
			props: true
		},
		// {
		// 	path: '/checkInTemplates',
		// 	name: 'checkInTemplates',
		// 	component: ReviewTemplates
		// },
		// {
		// 	path: '/checkInTemplate/:id',
		// 	name: 'checkInTemplate',
		// 	component: ReviewTemplate,
		// 	props: route => ({ id: route.params.id })
		// },
		// {
		// 	path: '/checkInTemplate/:id/edit',
		// 	name: 'checkInTemplateEdit',
		// 	component: ReviewTemplateEdit,
		// 	props: route => ({ id: route.params.id })
		// },
		// {
		// 	path: '/checkInTemplates/create/',
		// 	name: 'checkInTemplateCreate',
		// 	component: ReviewTemplateCreate,
		// 	props: route => ({ id: route.params.id })
		// },
		{
			path: '/categories',
			name: 'categories',
			component: () => import('@/pages/settings/PageCategories' /* webpackChunkName: "settings" */)
		},
		{
			path: '/certifications',
			name: 'certifications',
			component: () => import('@/pages/certifications/PageCertifications' /* webpackChunkName: "certifications" */),
			meta: {
                requiredModule: ProductModule.Compliance
			}
		},
		{
			path: '/certificationSettings',
			name: 'certificationSettings',
			component: () => import('@/pages/certifications/PageCertificationSettings.vue' /* webpackChunkName: "settings" */),
			meta: {
                requiredModule: ProductModule.Compliance
			}
		},
		{
			path: '/defaultDiscussionPoints',
			name: 'defaultDiscussionPoints',
			component: () => import('@/pages/settings/PageDefaultDiscussionPoints' /* webpackChunkName: "settings" */)
		},
		{
			path: '/departments',
			name: 'departments',
			component: () => import('@/pages/settings/PageDepartments' /* webpackChunkName: "settings" */)
		},
		{
			path: '/coreValues',
			name: 'coreValues',
			component: () => import('@/pages/PageCoreValues' /* webpackChunkName: "coreValues" */)
		},
		{
			path: '/positionTemplates',
			name: 'positionTemplates',
			component: () => import('@/pages/positionTemplate/PagePositionTemplates' /* webpackChunkName: "positionTemplates" */),
			props: true,
			meta: { featureId: FeatureId.POSITION_TEMPLATES_MANAGE, action: PermissionAction.USE }
		},
		{
			path: '/positionTemplate/create/',
			name: 'positionTemplateCreate',
			component: () => import('@/pages/positionTemplate/PagePositionTemplateCreate' /* webpackChunkName: "positionTemplates" */),
			meta: { featureId: FeatureId.POSITION_TEMPLATES_MANAGE, action: PermissionAction.USE }
		},
		{
			path: '/positionTemplate/:id/',
			name: 'positionTemplate',
			component: () => import('@/pages/positionTemplate/PagePositionTemplate' /* webpackChunkName: "positionTemplates" */),
			props: true,
			meta: { featureId: FeatureId.POSITION_TEMPLATES_MANAGE, action: PermissionAction.USE }
		},
		{
			path: '/positionTemplate/:id/edit',
			name: 'positionTemplateEdit',
			component: () => import('@/pages/positionTemplate/PagePositionTemplateEdit' /* webpackChunkName: "positionTemplates" */),
			props: true,
			meta: { featureId: FeatureId.POSITION_TEMPLATES_MANAGE, action: PermissionAction.USE }
		},
		{
			path: '*',
			name: 'notFound',
			component: () => import('@/pages/PageNotFound' /* webpackChunkName: "utilityPages" */)
		},
		{
			path: '/orgChart',
			name: 'orgChart',
			component: () => import('@/pages/PageOrgChart' /* webpackChunkName: "orgChart" */)
		},
		{
			path: '/feedback',
			name: 'feedback',
			component: () => import('@/pages/PageAppFeedback' /* webpackChunkName: "appFeedback" */)
		},
		{
			path: '/hrDocuments',
			name: 'hrDocuments',
			component: () => import('@/pages/hrDocuments/PageHRDocuments' /* webpackChunkName: "hrDocuments" */)
		},
		{
			path: '/hrDocuments/policies',
			name: 'hrPolicies',
			component: () => import('@/pages/hrDocuments/PageHRPolicies' /* webpackChunkName: "hrDocuments" */)
		},
		{
			path: '/hrDocuments/:id',
			name: 'hrDocument',
			component: () => import('@/pages/hrDocuments/PageHRDocument' /* webpackChunkName: "hrDocuments" */),
			props: true
		},
		{
			path: '/hrDocuments/:id/edit',
			name: 'hrDocumentEdit',
			component: () => import('@/pages/hrDocuments/PageHRDocumentEdit' /* webpackChunkName: "hrDocuments" */),
			props: true,
			meta: { featureId: FeatureId.COMPANY_POLICIES_MANAGE, action: PermissionAction.USE }
		},
		{
			path: '/hrDocument/create/',
			name: 'hrDocumentCreate',
			component: () => import('@/pages/hrDocuments/PageHRDocumentCreate' /* webpackChunkName: "hrDocuments" */),
			meta: { featureId: FeatureId.COMPANY_POLICIES_MANAGE, action: PermissionAction.USE }
		},
		{
			path: '/meetingLocations',
			name: 'meetingLocations',
			component: () => import('@/pages/settings/PageMeetingLocations' /* webpackChunkName: "settings" */)
		},
		{
			path: '/prTemplates',
			name: 'prTemplates',
			component: () => import('@/pages/performanceReviews/PagePerformanceReviewTemplates' /* webpackChunkName: "prTemplates" */),
		},
		{
			path: '/prTemplate/:id',
			name: 'prTemplate',
			component: () => import('@/pages/performanceReviews/PagePerformanceReviewTemplate' /* webpackChunkName: "prTemplates" */),
			props: true
		},
		{
			path: '/prTemplate/:id/edit',
			name: 'prTemplateEdit',
			component: () => import('@/pages/performanceReviews/PagePerformanceReviewTemplateEdit' /* webpackChunkName: "prTemplates" */),
			props: true
		},
		{
			path: '/prTemplates/create/',
			name: 'prTemplateCreate',
			component: () => import('@/pages/performanceReviews/PagePerformanceReviewTemplateCreate' /* webpackChunkName: "prTemplates" */)
		},
		{
			path: '/reports',
			name: 'reports',
			component: () => import('@/pages/reports/PageReports' /* webpackChunkName: "reports" */)
		},
		{
			path: '/report/:name',
			name: 'report',
			component: () => import('@/pages/reports/PageReport' /* webpackChunkName: "reports" */),
			props: true
		},
		{
			path: '/terms',
			name: 'terms',
			component: () => import('@/pages/PageTerms' /* webpackChunkName: "utilityPages" */)
		},
		{
			path: '/goals',
			name: 'goals',
			component: () => import('@/pages/goals/PageGoals' /* webpackChunkName: "goals" */)
		},
		{
			path: '/myGoals',
			name: 'myGoals',
			component: () => import('@/pages/goals/PageMyGoals' /* webpackChunkName: "goals" */)
		},
		{
			path: '/goal/:id',
			name: 'goal',
			component: () => import('@/pages/goals/PageGoalStatusReport' /* webpackChunkName: "goals" */),
			props: true
		},
		{
			path: '/dailyScrum',
			name: 'dailyScrum',
			component: () => import('@/pages/dailyScrum/PageDailyScrum' /* webpackChunkName: "dailyScrums" */)
		},
		{
			path: "/company/companySettings",
			name: "companySettings",
			component: () => import("@/pages/settings/PageCompanySettings" /* webpackChunkName: "settings" */)
		},
		{
			path: "/company/features",
			name: "features",
			component: () => import("@/pages/settings/PageFeatures" /* webpackChunkName: "settings" */)
		},
		{
			path: "/company/billing",
			name: "billing",
			component: () => import("@/pages/settings/PageBilling" /* webpackChunkName: "settings" */)
		},
		{
			path: "/company/permissions",
			name: "permissions",
			component: () => import("@/pages/settings/PagePermissions" /* webpackChunkName: "settings" */)
		},
		// {
		// 	path: "/company/setup",
		// 	name: "accountSetup",
		// 	component: () => import("@/pages/accountSetup/PageAccountSetup" /* webpackChunkName: "settings" */)
		// },
		// {
		// 	path: "/company/setup/import-employees",
		// 	name: "setupImportEmployees",
		// 	component: () => import("@/pages/accountSetup/PageAddEmployees" /* webpackChunkName: "settings" */)
		// },
		// {
		// 	path: "/company/setup/company-details",
		// 	name: "setupCompanyDetails",
		// 	component: () => import("@/pages/accountSetup/PageAddCompanyDetails" /* webpackChunkName: "settings" */)
		// }
	]
});

router.beforeResolve(async (to, from, next) => {
	// Start the route progress bar if this isn't an initial page load
	if (to.name) {
		NProgress.start();
	}

	await waitForLoggedInEmployee();

	const { featureId, action, requiredRole } = to.meta || {};

	// Check if the route requires feature access
	if (featureId && action) {
		const hasFeatureAccess = store.getters['privileges/hasFeatureAccess'](featureId, action);
		if (!hasFeatureAccess) {
			return next({ name: 'notFound' });
		}
	}

	// Check if the route requires a specific role
	if (requiredRole) {
		const hasRole = store.getters['privileges/hasRole'](requiredRole);
		if (!hasRole) {
			return next({ name: 'notFound' });
		}
	}

	next(); // Proceed to the route
});

router.afterEach((to, from) => {
	// Complete the animation of the route progress bar.
	NProgress.done();
});

async function waitForLoggedInEmployee() {
	const MAX_RETRIES = 25;
	const RETRY_INTERVAL = 150;

	for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
		if (store.getters['loggedInEmployee']) {
			return;
		}
		await new Promise(resolve => setTimeout(resolve, RETRY_INTERVAL));
	}
}

export default router;